import "font-awesome/css/font-awesome.min.css";

// Material Design Icons
import '@mdi/font/css/materialdesignicons.css'

import Vue from "vue";
import Vuetify from "vuetify/lib";

Vue.use(Vuetify);

export default new Vuetify({
  breakpoint: {
    thresholds: {
      xl: 2000,
    },
  },
  theme: {
    options: {
      customProperties: true, // Enable CSS variables
    },
    themes: {
      light: {
        primary: "#1976D2",
        secondary: "#424242",
        accent: "#82B1FF",
        error: "#FF5252",
        info: "#2196F3",
        success: "#4CAF50",
        warning: "#FFC107",
      },
    },
  },
  icons: {
    iconfont: "mdi" || "fa4" || "fa",
  },
});